import { Injectable } from '@angular/core';
import * as ExcelJS from 'exceljs';
import * as saveAs from 'file-saver';
import { IMenuCategoryDto } from '../models';
import { CommonConstants } from 'src/app/shared/constant';
@Injectable()
export class ExcelService {
  menuPricingType = CommonConstants.MenuPricingType;

  constructor() {}

  public exportAsExcelFile(
    customHeader: string[],
    data: any[],
    fileName: string,
    headerWidth?: number[]
  ) {
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet('My Sheet');

    const headers = Object.keys(data[0]);
    const headerRow = worksheet.addRow(customHeader);

    headerRow.eachCell((cell, number) => {
      cell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'FFFFFF00' },
        bgColor: { argb: 'FF0000FF' },
      };
      cell.border = {
        top: { style: 'thin' },
        left: { style: 'thin' },
        bottom: { style: 'thin' },
        right: { style: 'thin' },
      };
    });

    data.forEach((item) => {
      const row: any = [];
      headers.forEach((header) => {
        row.push(item[header]);
      });
      worksheet.addRow(row);
    });

    if (headers.length === headerWidth?.length) {
      headers.forEach((x, i: number) => {
        worksheet.getColumn(i + 1).width = headerWidth[i];
      });
    }

    workbook.xlsx.writeBuffer().then((buffer: any) => {
      const blob = new Blob([buffer], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      });
      saveAs(blob, `${fileName}.xlsx`);
    });
  }

  public exportAsExcelFileMultiple(fileName: string, data: IMenuCategoryDto[]) {
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet('Items');
    const worksheet2 = workbook.addWorksheet('Modifiers');
    worksheet.columns = [
      { header: 'Category', key: 'category', width: 20 },
      { header: 'Sub Category', key: 'subCategory', width: 20 },
      { header: 'Item Id', key: 'itemId', width: 10 },
      { header: 'Menu Item', key: 'menuItem', width: 20 },
      { header: 'Description', key: 'description', width: 25 },
      { header: 'Pricing Type', key: 'pricingType', width: 10 },
      { header: 'Price', key: 'price', width: 10 },
    ];

    worksheet2.columns = [
      { header: 'Item Id', key: 'itemId', width: 10 },
      { header: 'Item Name', key: 'itemName', width: 20 },
      { header: 'Group Name', key: 'groupName', width: 20 },
      { header: 'Addon Name', key: 'addonName', width: 20 },
      { header: 'Min', key: 'min', width: 5 },
      { header: 'Max', key: 'max', width: 5 },
      { header: 'Type', key: 'type', width: 10 },
    ];

    worksheet.getRow(1).eachCell((cell) => {
      cell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'FFFF00' },
      };
      cell.font = {
        bold: true,
        color: { argb: '000' },
      };
    });

    worksheet2.getRow(1).eachCell((cell) => {
      cell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'FFFF00' },
      };
      cell.font = {
        bold: true,
        color: { argb: '000' },
      };
    });

    //Items sheet
    data.forEach((category) => {
      category.subCategory.forEach((subcategory) => {
        subcategory.menuItems.forEach((item) => {
          if (item.pricingType == this.menuPricingType.Single) {
            worksheet.addRow({
              category: category.name,
              subCategory: subcategory.name,
              itemId: item.id,
              menuItem: item.itemName,
              description: item.description,
              pricingType: 'Single',
              price: item.unitPrice,
            });
          } else {
            item.menuAddons.forEach((group) => {
              group.menuAddonItems.forEach((modifier) => {
                if (group.order < 0) {
                  worksheet.addRow({
                    category: category.name,
                    subCategory: subcategory.name,
                    itemId: item.id,
                    menuItem: item.itemName,
                    description: item.description,
                    pricingType: modifier.name,
                    price: modifier.price,
                  });
                }
              });
            });
          }
        });
      });
    });

    data.forEach((category) => {
      category.subCategory.forEach((subcategory) => {
        subcategory.menuItems.forEach((item) => {
          item.menuAddons.forEach((group) => {
            group.menuAddonItems.forEach((modifier) => {
              if (group.order >= 0) {
                worksheet2.addRow({
                  itemId: item.id,
                  itemName: item.itemName,
                  groupName: group.groupName,
                  addonName: modifier.name,
                  min: group.minChoice,
                  max: group.maxChoice,
                  type: group.addonSelectionType == 1 ? 'Single' : 'Multiple',
                });
              }
            });
          });
        });
      });
    });
    workbook.xlsx.writeBuffer().then((buffer: any) => {
      const blob = new Blob([buffer], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      });
      saveAs(blob, `${fileName}.xlsx`);
    });
  }
}
